module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container centre-column"
  }, [(_vm.$route.query.redirect) ? _c('p', [_vm._v("\n    You need to log in first.\n  ")]) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "form-signin"
  }, [_c('h2', [_vm._v("Please log in")]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: _vm.validateEmail ? '' : 'has-error'
  }, [_c('label', {
    staticClass: "sr-only",
    attrs: {
      "for": "inputEmail"
    }
  }, [_vm._v("Email Address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "inputEmail",
      "placeholder": "Email address",
      "required": "",
      "autofocus": ""
    },
    domProps: {
      "value": _vm._s(_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: _vm.validatePassword ? '' : 'has-error'
  }, [_c('label', {
    staticClass: "sr-only",
    attrs: {
      "for": "inputPassword"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "inputPassword",
      "placeholder": "Password",
      "required": ""
    },
    domProps: {
      "value": _vm._s(_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-primary btn-block",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_vm._v("Log in")])]), _vm._v(" "), _c('div', {
    staticClass: "centre-column"
  }, [_c('p', [_c('router-link', {
    attrs: {
      "to": {
        name: 'forgot-password'
      }
    }
  }, [_vm._v("forgot password")])], 1), _vm._v(" "), (_vm.error) ? _c('p', {
    staticClass: "error"
  }, [_vm._v("email or password is not correct")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6feb489a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 505
// module chunks = 2